export default "__VITE_ASSET__DuSyN1FH__"